<template>
    <button
        class="chat-fab"
        @click="toggleChat"
        :class="{ 'has-messages': hasMessages }"
        aria-label="Open AI Assistant"
    >
        <span class="material-symbols-outlined">
            {{ isOpen ? 'close' : 'smart_toy' }}
        </span>
        <span v-if="messageCount > 0 && !isOpen" class="badge-dot"></span>
    </button>
</template>

<script>
/**
 * FloatingChatButton Component
 * Floating action button to toggle the chat panel visibility.
 * Shows message count badge when panel is closed.
 */
import { mapState, mapActions } from 'vuex'

export default {
    name: 'FloatingChatButton',
    computed: {
        ...mapState('chat', {
            isOpen: 'isOpen',
            messages: 'messages',
        }),
        /** @returns {boolean} Whether there are messages in history */
        hasMessages() {
            return this.messages.length > 0
        },
        /** @returns {number} Number of messages */
        messageCount() {
            return this.messages.length
        },
    },
    methods: {
        ...mapActions('chat', ['toggleChat']),
    },
}
</script>

<style scoped>
.chat-fab {
    position: fixed;
    bottom: 32px;
    right: 32px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: none;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-container) 100%);
    color: var(--color-on-primary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(119, 89, 40, 0.4);
    transition: all 0.3s ease;
    z-index: 9997;
}

.chat-fab:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(119, 89, 40, 0.5);
}

.chat-fab:active {
    transform: scale(0.95);
}

.chat-fab .material-symbols-outlined {
    font-size: 28px;
}

.chat-fab.has-messages {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        box-shadow: 0 4px 16px rgba(119, 89, 40, 0.4);
    }
    50% {
        box-shadow: 0 4px 24px rgba(119, 89, 40, 0.6);
    }
    100% {
        box-shadow: 0 4px 16px rgba(119, 89, 40, 0.4);
    }
}

.badge-dot {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--color-tertiary);
    border: 2px solid var(--color-on-primary);
}

@media (max-width: 768px) {
    .chat-fab {
        bottom: 100px;
        right: 16px;
        width: 56px;
        height: 56px;
    }

    .chat-fab .material-symbols-outlined {
        font-size: 24px;
    }
}
</style>
